// extracted by mini-css-extract-plugin
module.exports = {"remarkInfoContainer":"RemarkInfo_remarkInfoContainer__3qf75","remarkContent":"RemarkInfo_remarkContent__1VTIZ","operationHintText":"RemarkInfo_operationHintText__3GZ3S"};